import { render, staticRenderFns } from "./ThreatDetails.vue?vue&type=template&id=8f4b0848&scoped=true&"
import script from "./ThreatDetails.vue?vue&type=script&lang=js&"
export * from "./ThreatDetails.vue?vue&type=script&lang=js&"
import style0 from "./ThreatDetails.vue?vue&type=style&index=0&id=8f4b0848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4b0848",
  null
  
)

export default component.exports